import Navbar from "../components/Navbar/Navbar";
import { Outlet } from "react-router-dom";
import Footer from "../components/Footer/Footer";
import SevaGuide from "../components/SevaGuide/SevaGuide";
import { useRegionalExperience } from "../hooks/useRegionalExperience";

const Layout = () => {
  const { siteConfig } = useRegionalExperience();
  const announcement = siteConfig?.visitAnnouncement || { enabled: false };

  return (
    <>
      <Navbar announcement={announcement} />
      {/* Spacer: the visit strip adds height to the fixed header; push content down to match. */}
      {announcement.enabled ? <div className="h-10" aria-hidden="true" /> : null}
      <div className="">
        <Outlet />
      </div>
      <Footer />
      <SevaGuide />
    </>
  );
};

export default Layout;
